// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;


// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Header from "./components/Header";
// import Footer from "./components/Footer";
// import Home from "./pages/Home";
// import Login from "./pages/Login";
// import Register from "./pages/Register";
// import Notes from "./pages/Notes";
// import AddNote from "./pages/AddNote";
// import NoteDetails from "./pages/NoteDetails";
// import EditNote from "./pages/EditNote";
// import { AuthProvider } from "./context/AuthContext";
// import "./styles/global.css";

// export default function App() {
//   return (
//     <AuthProvider>
//       <BrowserRouter>
//         <Header />

//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/register" element={<Register />} />

//           <Route path="/notes" element={<Notes />} />
//           <Route path="/add-note" element={<AddNote />} />
//           <Route path="/note/:id" element={<NoteDetails />} />
//           <Route path="/edit-note/:id" element={<EditNote />} />

//         </Routes>

//         <Footer />
//       </BrowserRouter>
//     </AuthProvider>
//   );
// }




import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Notes from "./pages/Notes";
import AddNote from "./pages/AddNote";
import NoteDetails from "./pages/NoteDetails";
import EditNote from "./pages/EditNote";
import { AuthProvider } from "./context/AuthContext";
import "./styles/global.css";
import { pink } from "@mui/material/colors";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh", // full viewport height
           
          }}
        >
          <Header />

          {/* Main content */}
          <div
            style={{
              flex: 1,
             // takes remaining space to push footer down
            }}
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/add-note" element={<AddNote />} />
              <Route path="/note/:id" element={<NoteDetails />} />
              <Route path="/edit-note/:id" element={<EditNote />} />
            </Routes>
          </div>

          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
